import userInfo from '../store/userInfo';
export  const  checkPermission = {
    data(){
        return{
            permissions:[]
        }
    },
    store: userInfo,
    methods:{
        checkPermission(permission){
            return this.$store.getters.getPermissions.indexOf(permission) > -1;
        },
        checkNavigationMenu(navigationMenu) {
            return this.$store.getters.getNavigationMenus.indexOf(navigationMenu) > -1;
        }
    }
};
export default checkPermission
